import { z } from 'zod';
import { LANGS } from './constants.ts';

// Mirrors of Prisma enums. `packages/db` has a test that keeps them in sync.

export const Lang = z.enum(LANGS);
export type Lang = z.infer<typeof Lang>;

export const AudioQuality = z.enum(['AUTO', 'HIGH', 'LOW']);
export type AudioQuality = z.infer<typeof AudioQuality>;

export const StorySource = z.enum(['AI', 'FOLK', 'AUTHOR']);
export type StorySource = z.infer<typeof StorySource>;

export const StoryStatus = z.enum(['DRAFT', 'IN_REVIEW', 'SCHEDULED', 'PUBLISHED', 'ARCHIVED']);
export type StoryStatus = z.infer<typeof StoryStatus>;

export const ReviewStatus = z.enum(['PENDING', 'APPROVED', 'CHANGES_REQUESTED']);
export type ReviewStatus = z.infer<typeof ReviewStatus>;

export const UnlockVia = z.enum(['FREE', 'PREMIUM']);
export type UnlockVia = z.infer<typeof UnlockVia>;

export const SubscriptionStatus = z.enum(['ACTIVE', 'EXPIRED', 'CANCELLED']);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatus>;

export const SubscriptionSource = z.enum(['PAYMENT', 'MANUAL', 'PROMO']);
export type SubscriptionSource = z.infer<typeof SubscriptionSource>;

export const PaymentProviderCode = z.enum(['CLICK', 'PAYME', 'TELEGRAM_STARS', 'FAKE']);
export type PaymentProviderCode = z.infer<typeof PaymentProviderCode>;

export const PaymentStatus = z.enum([
  'CREATED',
  'PREPARED',
  'PAID',
  'CANCELLED',
  'FAILED',
  'REFUNDED',
]);
export type PaymentStatus = z.infer<typeof PaymentStatus>;

export const ContentJobType = z.enum([
  'GENERATE_STORY',
  'REVIEW_TEXT',
  'TTS',
  'AUDIO_PROCESS',
  'REGENERATE_TEXT',
  'REGENERATE_AUDIO',
  'VOICE_SAMPLE',
  'UPLOAD_PROCESS',
  'DIRECT_TAGS',
  'TTS_PREVIEW',
]);
export type ContentJobType = z.infer<typeof ContentJobType>;

export const JobStatus = z.enum(['QUEUED', 'RUNNING', 'SUCCEEDED', 'FAILED', 'CANCELLED']);
export type JobStatus = z.infer<typeof JobStatus>;

export const AdminRole = z.enum(['OWNER', 'EDITOR', 'VIEWER']);
export type AdminRole = z.infer<typeof AdminRole>;

export const BroadcastStatus = z.enum(['PENDING', 'RUNNING', 'DONE', 'FAILED', 'SKIPPED']);
export type BroadcastStatus = z.infer<typeof BroadcastStatus>;
